export default __webpack_public_path__ + "b466c00627d0be247c8a540692ce29ed.woff";